import { Link, useParams } from "react-router-dom";
import { useGlobalContext } from "./Context"
import { useLocation } from 'react-router-dom'
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import LoadingIcon from "./Components/LoadingIcon";
import { Col, Row, Alert, Descriptions } from 'antd';

const Detail = () => {
    const { id } = useParams();
    const [premises, setPremises] = useState();
    const [loading, setLoading] = useState(false);
    const [premiseNotFound, setPremiseNotFound] = useState(false);

    const { premisesList, shameList } = useGlobalContext();
    const location = useLocation();
    const { from } = location.state || { from: "home" };
    const baseURl = 'https://api.foodgrade.co.nz/';
    const detailUrl = `${baseURl}premisedetail?id=`;

    useEffect(() => {
        setLoading(true);
        setPremiseNotFound(false);

        const RetrieveDetail = async (id) => {
            await axios.get(`${detailUrl}${id}`)
                .then(res => {
                    setPremises(res.data);
                })
                .then(() => {
                    setLoading(false);
                    setPremiseNotFound(false);
                })
                .catch(err => {
                    setLoading(false);
                    setPremiseNotFound(true);
                });
        }

        let temp = undefined;

        if (from === "search") {
            if (premisesList.length !== 0) {
                temp = premisesList.find(p => p.Id === id);
                setPremises(temp);
                setLoading(false);
                setPremiseNotFound(false);                
            }
        }

        if (from === "shameList") {
            if (shameList.length !== 0) {
                temp = shameList.find(p => p.Id === id);
                setPremises(temp);
                setLoading(false);
                setPremiseNotFound(false);                
            }
        }

        if (temp === undefined) {
            RetrieveDetail(id);
        }

    }, [from, detailUrl, premisesList, id, shameList]);


    if (loading) {
        return (
            <Row>
                <Col span={24}>
                    <div className="row d-flex justify-content-center align-items-center">
                        <LoadingIcon />
                    </div>
                </Col>
            </Row>

        )
    }

    if (!loading && premiseNotFound) {
        return (
            <Row>
                <Col span={24}>
                    <Alert
                        message="Sorry, the premises doesn't exist."
                        type="warning" />
                </Col>
            </Row>

        )
    }

    if (premises) {
        const items = [
            {
                key: '1',
                label: 'Name',
                children: premises.Name.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }),
            },
            {
                key: '2',
                label: 'Address',
                children: premises.Address.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }),
            },
            {
                key: '3',
                label: 'Grade',
                children: premises.Grade.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }),
            },
            {
                key: '4',
                label: 'Expire Date',
                children: premises.ExpireDate.replace(/\w+/g, function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); }),
            }
        ];
        return (
            <>
                <Row style={{ marginTop: "10px" }}>
                    <Col span={24}>
                        {from === "home" ? (
                            <Link className="primary" to="/">
                                Back to Home
                            </Link>
                        ) : from === "search" ? (
                            <Link className="primary" to="/search">
                                Back to search results
                            </Link>
                        ) : (
                            <Link className="primary" to="/shamelist">
                                Back to Hall of Shame
                            </Link>
                        )}
                    </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                    <Col span={24}>
                        <Descriptions title="Premise Details" items={items} />
                    </Col>
                </Row>
            </>
        );
    }

}

export default Detail;
